export const environment = {
  isLocalDev: false,
  federationManifest: 'federation.manifest.uatm.json',
  idp: {
    issuer: 'https://api-services.uat.1placedessaisons.com/uatm/v1/oidc',
    clientId: 'be503ef2-2288-4b76-9ca9-3b9c1acd337a',
  },
  rmPermissionsCheckUrl: 'https://api-services.uat.1placedessaisons.com/uatm/v3/permissions/check',
  dataRefsBusinessUnitsUrl: 'https://api-services.uat.1placedessaisons.com/uatm/v1/businessUnits',
  requiredActionResourcesPermissions: {
    jade_admin: ['APP_JADE_MAIL_TO_TICKET'],
    'jade_api_mail-to-ticket_read_customer-service': [],
  },
};
